import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { TargetLabel } from 'consts/targetLabel';
import { changeActiveObjective, updateIsObjectiveSubsectionChange } from 'store/objective/reducer';
import { CodeNameModel } from 'components/common/types';
import { IconSize } from 'components/common/types/Input.types';
import { DirectSalesObjectiveTarget } from 'components/common/types/DirectSalesCampaign.types';
import useTarget from '../../../components/TargetsPanel/useTarget';
import TargetSection from '../../../TargetSection';
import { TargetType } from '../../../TargetSection/TargetSection.types';

interface ObjectiveTargetProps {
  objectiveTarget: DirectSalesObjectiveTarget;
  targetType: TargetType;
  label: TargetLabel;
  icon: string;
}

const ObjectiveTarget: React.FC<ObjectiveTargetProps> = ({ objectiveTarget, targetType, label, icon }) => {
  const dispatch = useDispatch();

  const updateObjectiveTarget = (
    targetValue: number | CodeNameModel,
    valueType: 'value' | 'priority' | 'greenTolerance' | 'orangeTolerance',
  ): void => {
    if (valueType === 'value' && !targetValue) {
      const { value, ...targetWithoutValue } = objectiveTarget;
      dispatch(changeActiveObjective({ [targetType]: targetWithoutValue }));
      return;
    }

    dispatch(
      changeActiveObjective({
        [targetType]: { ...objectiveTarget, [valueType]: targetValue },
      }),
    );
  };

  const target = useTarget({
    target: objectiveTarget.value,
    targetCriteria: objectiveTarget,
    onValueChange: (value: number) => {
      updateObjectiveTarget(value, 'value');
    },
    onPriorityChange: (priority: CodeNameModel) => {
      updateObjectiveTarget(priority, 'priority');
    },
    onGreenToleranceChange: (greenTolerance: number) => {
      updateObjectiveTarget(greenTolerance, 'greenTolerance');
    },
    onOrangeToleranceChange: (orangeTolerance: number) => {
      updateObjectiveTarget(orangeTolerance, 'orangeTolerance');
    },
  });

  useEffect(() => {
    dispatch(updateIsObjectiveSubsectionChange(target.isChange));
  }, [target.isChange]);

  return (
    <TargetSection label={label} target={target} icon={icon} iconSize={IconSize.EXTRA_SMALL} targetType={targetType} />
  );
};

export default ObjectiveTarget;
